export const colors = {
  main: '#B0CA44',
  secondary: '#916DA0',
  other: '#B0CA44',
  back: 'grey',
  red: '#D40132',
  black: '#000000',
  facebook: '#fff',
  twitter: '#fff',
  instagram: '#fff',
  special: '#B0CA44' 
}

export const fonts = {
  font: 'Lato',
  bold: '700',
  semibold: '600',
  regular: '400',
  light: '300'
}

export const align = {
  center: 'center',
  left: 'left',
  right: 'right'
}

export const lang = {
  title_vm: 'Le titre 2'
}